import { action, makeAutoObservable } from "mobx";
import ElementModel from "../../model/ElementModel";
import { RootStore } from "../index";
import { ISectionMenuL1, ISectionMenuL2 } from "../../interface/ISection";
import { HelperCatalog } from "../../helper/HelperCatalog";

export class PageCatalogStore {
  private rootStore: RootStore | undefined;

  pagination = {
    countPage: 1,
    countRow: 1,
    currentPage: 1,
  };

  urlFilter: string | undefined;

  orderModel: string = "";
  orderField: string = "id";
  orderBy: string = "DESC";

  arItems = [];
  productList = [];

  public error: string = "";
  private section1: null | string = "";
  private section2: null | string = "";
  private title: string = "Каталог";

  openCatalog: boolean = false

  constructor(rootStore?: RootStore) {
    makeAutoObservable(this);
    this.rootStore = rootStore;
  }

  onCurrentPage = (page: number) => {
    let baseUrl =
      window.location.protocol +
      "//" +
      window.location.host +
      window.location.pathname;
    let newUrl = baseUrl + "?page=" + page;
    // @ts-ignore
    window.history.pushState(null, null, newUrl);
    this.pagination.currentPage = page;
    this.reload();
  };

  init(
    code1: string | undefined,
    code2: string | undefined,
    filter: string | undefined,
    page: number = 1
  ) {

    this.urlFilter = filter;
    if (code1 === undefined) {
      this.section1 = null;
    } else {
      this.section1 = code1;
    }
    if (code2 === undefined) {
      this.section2 = null;
    } else {
      this.section2 = code2;
    }
    this.rootStore?.componentFilterCatalogStore.init(filter);
    this.reload(true,page);
  }

  reload(init: boolean = false,page:number=1) {
 
 
    if (init) {
      this.pagination.currentPage = 1;
    }
    if (init && page) {
        this.pagination.currentPage = page;
      }


     // this.setUrlPage();

    // обновляем список у фильтра
    this.rootStore?.componentFilterCatalogStore.setFilter();

    ElementModel.getCatalog(
      {
        json: {
          clientId: this.rootStore?.mainStore.getClientId(),
          limit: 32,
          filter: this.setFilter(),
          sort: this.setSort(),
        },
        page: this.pagination.currentPage,
      },
      this.setCatalog,
      this.setError
    );
  }

  reloadMain = () => {
    let clientId = this.rootStore?.mainStore.getClientId();
    this.pagination.currentPage = 1;
    // обновляем список у фильтра
    this.rootStore?.componentFilterCatalogStore.setFilter();
    ElementModel.getCatalog(
      {
        json: {
          clientId: clientId,
          limit: 32,
          filter: this.setFilter(),
          sort: this.setSort(),
        },
        page: this.pagination.currentPage,
      },
      this.setCatalogMain,
      this.setError
    );

    this.rootStore?.componentFilterCatalogStore.init(this.urlFilter);
  };

  getAllCatalogList = () => {
    let clientId = this.rootStore?.mainStore.getClientId();
    ElementModel.getAllCatalogList(
      {
        json: {
          clientId: clientId,
        },
      },
      this.setProductList,
      this.setError
    );
  };

  getBaseUrlCatalog() {
    let s = "/catalog/";
    if (this.section1 !== "undefined") {
      s += this.section1 + "/";
    }
    if (this.section2 !== "undefined") {
      s += this.section2 + "/";
    }
    return s;
  }

  setUrlPage() {
    let url = this.getBaseUrlCatalog();
    let sFilter = this.rootStore?.componentFilterCatalogStore.setFilterUrl();
    if (sFilter) {
      url += "filter/" + sFilter;
    }
    //ToDo task number 45215 from
    if (window.location.search.length) {
      let page = window.location.search;
      // @ts-ignore
      url += page;
    }
    // @ts-ignore
    window.history.pushState(null, null, url);
  }

  setFilter() {
    let filter = {};
    // @ts-ignore
    filter["props"] = {};
    filter = this.setFilterProps(filter);
    filter = this.SetSection(filter);
    return filter;
  }

  setFilterProps(filter: any) {
    const {
      arBrandChecked,
      arKindChecked,
      isNoveltyFilter,
      isSelloutFilter,
      isSaleFilter,
      isLoyaltyFilter,
    } =
      // @ts-ignore
      this.rootStore.componentFilterCatalogStore;

    if (arBrandChecked.length) {
      filter["props"]["brand"] = arBrandChecked;
    }
    if (arKindChecked.length) {
      filter["props"]["itemType"] = arKindChecked;
    }

    if (isNoveltyFilter) {
      filter["props"]["isNovelty"] = true;
    }
    if (isSelloutFilter) {
      filter["props"]["isSellout"] = true;
    }
    if (isSaleFilter) {
      filter["props"]["isSale"] = true;
    }
    if (isLoyaltyFilter) {
      filter["props"]["isIncludeLoyaltyProgram"] = true;
    }
    return filter;
  }

  @action
  setCatalog = (result: any) => {
    this.arItems = result.data.rows;
    this.pagination = result.data.pagination;
    this.rootStore?.basePageStore
      .setBreadCrumbs(result.data.BreadCrumbs, "catalog")
      .setTitleInBreadCrumbs();
  };

  @action
  setCatalogMain = (result: any) => {
    this.arItems = result.data.rows;
    this.pagination = result.data.pagination;
  };
  @action
  setProductList = (result: any) => {
    this.productList = result.data.rows;
  };

  @action
  setError = (error: any) => {
    if (
      error !== undefined &&
      error.response !== undefined &&
      error.response.data !== undefined &&
      error.response.data.message !== undefined
    ) {
      this.error = String(error.response.data.message);
    }
  };

  public SetSection(filter: {} = {}) {
    if (this.section1 === "" && this.section2 === "") {
      return filter;
    }
    if (this.section1 !== "undefined" || this.section2 !== "undefined") {
      // @ts-ignore
      filter["sectionIds"] = [];
      if (this.section1 !== "undefined") {
        // @ts-ignore
        filter["sectionIds"].push(this.section1);
      }
      if (this.section2 !== "undefined") {
        // @ts-ignore
        filter["sectionIds"].push(this.section2);
      }
    }
    return filter;
  }

  @action
  setPageCatalog = () => {
    this.rootStore?.basePageStore
      .setBreadCrumbs([], "catalog")
      .setTitleInBreadCrumbs();
    this.rootStore?.componentFilterCatalogStore.resetShowFilter();
    this.setOpenCatalog()
  };

  @action
  setOpenCatalog = () => {
    this.openCatalog = !this.openCatalog
  };

  @action
  public setPageCatalogL1 = (el1: ISectionMenuL1) => {
    this.rootStore?.componentFilterCatalogStore.resetShowFilter();
    this.section1 = el1.code;
    this.rootStore?.basePageStore
      .setBreadCrumbs(
        [
          {
            url: HelperCatalog.getUrlList(el1, null),
            name: el1.name,
          },
        ],
        "catalog"
      )
      .setTitleInBreadCrumbs();
    this.title = el1.name;
    this.rootStore?.basePageStore.setTitleInBreadCrumbs();
    this.reload(true);
  };

  @action
  public setPageCatalogL2 = (
    el1: ISectionMenuL1,
    el2: ISectionMenuL2 | null
  ) => {
    this.rootStore?.componentFilterCatalogStore.resetShowFilter();
    this.section1 = el1.code;
    if (el2 === null) {
      this.title = el1.name;
      this.rootStore?.basePageStore
        .setBreadCrumbs(
          [
            {
              url: HelperCatalog.getUrlList(el1, el2),
              name: el1.name,
            },
          ],
          "catalog"
        )
        .setTitleInBreadCrumbs();
    } else {
      this.title = el2.name;
      this.rootStore?.basePageStore
        .setBreadCrumbs(
          [
            { url: HelperCatalog.getUrlList(el1, null), name: el1.name },
            { url: HelperCatalog.getUrlList(el1, el2), name: el2.name },
          ],
          "catalog"
        )
        .setTitleInBreadCrumbs();
    }
    this.reload(true);
  };

  private setSort() {
    return {
      orderModel: this.orderModel,
      orderField: this.orderField,
      orderBy: this.orderBy,
    };
  }

  @action clearSort = () => {
    this.orderField = "id";
    this.orderModel = "";
    this.orderBy = "DESC";
    this.reload(true);
  };

  @action
  public setSortParams = (orderField: string) => {
    if (this.orderField === orderField && this.orderBy === "ASC") {
      this.clearSort();
      return false;
    }

    if (this.orderField === orderField) {
      this.orderBy = this.orderBy === "ASC" ? "DESC" : "ASC";
    } else {
      this.orderBy = "DESC";
    }
    if (orderField === "price") {
      this.orderModel = "prices";
    } else {
      this.orderModel = "";
    }
    this.orderField = orderField;
    this.reload(true);
  };
}
